import { Message, Room } from "@/types/chatTypes";
import { create } from "zustand";

interface SocketActions {
  setSocketId: (socketId: string) => void;
  setUser: (user: string) => void;
  addChat: (data: Message) => void;
  setRoom: (room: Room | null) => void;
}

interface SocketState {
  socketId: string;
  user: string;
  chat: Message[];
  room: Room | null;
  actions: SocketActions;
}

const useSocketStore = create<SocketState>((set) => ({
  socketId: "",
  user: "",
  chat: [],
  room: null,
  actions: {
    setSocketId: (socketId: string) => set({ socketId }),
    setUser: (user: string) => set({ user }),
    addChat: (data: Message) =>
      set((state) => ({ chat: [...state.chat, data] })),
    setRoom(room) {
      set((state) => ({
        room: state.room === room ? null : room,
      }));
    },
  },
}));

export const useSocketActions = () => useSocketStore((state) => state.actions);
export default useSocketStore;
